module.exports = __webpack_public_path__ + "vue/img/02.b91e7699.png";